<template>
  <b-sidebar
    id="sidebar-mark-report-monitoring"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">

      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Mark') }}
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />
      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="monitoringReportMark">
          <b-form-group
            :label="$t('Status')"
            label-for="status"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Status')"
              rules="required"
            >
              <v-select
                id="status"
                v-model="status"
                :state="errors.length > 0 ? false:null"
                :reduce="(option) => option.id"
                :options="statuses"
                :get-option-label="(option) => $langName(option.name)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <!-- Form Actions -->
        </validation-observer>
        <div class="d-flex mt-2">
          <b-button
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Create') }}
          </b-button>
          <b-button
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BSidebar,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'
import store from '@/store'

export default {
  name: 'MarkReportMonitoring',
  components: {
    ValidationProvider,
    BSidebar,
    BButton,
    BForm,
    BFormGroup,
    vSelect,
    ValidationObserver,
  },
  data() {
    return {
      status: null,
      required,
    }
  },
  computed: {
    monitoringReport() {
      return this.$store.state.monitoringReport.monitoringReport
    },
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.freshData(hide)
    },
    submit(hide) {
      this.$refs.monitoringReportMark.validate().then(success => {
        if (success) {
          this.$createSwal(this, { id: this.monitoringReport.id, status: this.status }, 'monitoringReport/markReport', () => {
            this.$emit('refetchData')
          })
          this.freshData(hide)
        }
      })
    },
    freshData(hide) {
      this.$store.commit('monitoringReport/GET', null)
      this.status = null
      hide()
    },
  },
  setup() {
    const {
      statuses, PENDING, REJECTED, ACCEPTED,
    } = store.state.monitoringReport

    return {
      REJECTED,
      ACCEPTED,
      statuses: statuses.filter(status => status.id !== PENDING),
    }
  },
}
</script>
<style scoped>

</style>
